import { render } from "./program-actions.vue?vue&type=template&id=3d1b2709&scoped=true"
import script from "./program-actions.vue?vue&type=script&lang=js"
export * from "./program-actions.vue?vue&type=script&lang=js"

import "./program-actions.vue?vue&type=style&index=0&id=3d1b2709&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1b2709"]])

export default __exports__